// Slick Carousel
import Glide from '@glidejs/glide'

class HomeCarousel {
    constructor() {
        // element that will be wrapped
        const carousel = document.querySelector('.home-carousel');

        if(carousel) {
            const carouselTrack = document.querySelector('.home-carousel .wp-block-group');
            const carouselSlides = carouselTrack.querySelector('.home-carousel .wp-block-group .wp-block-gallery');
            const carouselIndividualSlide = carouselTrack.querySelectorAll('.home-carousel .wp-block-group .wp-block-gallery .wp-block-image');

            // Add Glide classes
            carouselTrack.classList.add("glide__track");
            carouselTrack.dataset.glideEl = "track";
            carouselSlides.classList.add("glide__slides");
            carouselIndividualSlide.forEach((item) => {
                item.classList.add("glide__slide");
            });

            // Tweak styles
            carousel.style.overflow = 'hidden';
            carouselSlides.style.flexWrap = 'nowrap';

            var fullWidthGlide = new Glide('.home-carousel', {
                type: "carousel",
                perView: 1,
                autoplay: carouselIndividualSlide.length > 1 ? 3000 : false,
                peek: 0,
                gap: 0
            }).mount()
        }

    }
}

export default HomeCarousel;
